<template>
  <v-app>
    <v-app-bar v-if="$route.path !== '/login'"
      app
      color="primary"
      dark
    >
      <v-toolbar-title>{{ lang[$globalData.appLang][$route.name] }}</v-toolbar-title>
    </v-app-bar>
      <v-navigation-drawer
        v-model="drawer"
        absolute
        right
        temporary
      >
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                {{ $globalData.appData.user.voornaam }} {{ $globalData.appData.user.achternaam }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ $globalData.appData.user.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-group
            :value="false"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ lang[$globalData.appLang].taal }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              @click.stop="selectLang('nl')"
            >
              <v-list-item-action>
                <v-icon v-if="$globalData.appLang == 'nl'">mdi-check</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ lang[$globalData.appLang].nl }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              @click.stop="selectLang('en')"
            >
              <v-list-item-action>
                <v-icon v-if="$globalData.appLang == 'en'">mdi-check</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ lang[$globalData.appLang].en }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
    <v-main>
      <router-view/>
    </v-main>
    
    <v-bottom-navigation v-if="$route.path !== '/login'"
      :value="$route.name"
      app
      height="70"
      color="primary"
    >
      <v-btn
        value="diensten"
        @click.stop="$router.push({ path: '/' })"
      >
        <span>{{ lang[$globalData.appLang].diensten }}</span>

        <v-icon>mdi-calendar-clock</v-icon>
      </v-btn>
      <v-btn
        @click.stop="drawer = !drawer"
        class="pt-2"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-bottom-navigation>
    
  </v-app>
</template>

<script>
import './assets/custom.css'

export default {
  name: 'App',

  data: () => ({
    lang: {
      nl: {
        diensten: 'Diensten',
        verlof: 'Verlof',
        onkosten: 'Onkosten',
        taal: 'Taal',
        nl: 'Nederlands',
        en: 'Engels',
      },
      en: {
        diensten: 'Shifts',
        verlof: 'Leave',
        onkosten: 'Expenses',
        taal: 'Language',
        nl: 'Dutch',
        en: 'English',
      },
    },
    drawer: false,
  }),
  mounted () {
  },
  methods: {
    selectLang(lang) {
      this.$globalData.appLang = lang
      this.menu = false
      this.langMenu = false
    },
  }
};
</script>
